<template>
    <!-- Sección Diagnósticos -->
    <div ref="diagnosticsSection" class="diagnosis-section-modern">
        <div class="section-header-modern">
            <div class="header-title-modern">
                <i class="fas fa-diagnoses"></i>
                <h4>Diagnósticos y Problemas Clínicos</h4>
            </div>
        </div>

        <!-- Descripción de Diagnósticos / Problemas Clínicos -->
        <div v-if="isVisible('clinicalProblems')">
            <div v-if="!isClinicalProblemsActive" class="add-fields-section">
                <button
class="add-field-btn" title="Agregar Diagnósticos o problemas clínicos"
                    @click="addClinicalProblems">
                    <i class="fas fa-file-medical-alt"></i>
                    <span>{{ clinicalProblemsLabel }}</span>
                </button>
            </div>

            <div v-if="isClinicalProblemsActive" class="form-group-modern">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-file-medical-alt"></i>
                            <span>{{ clinicalProblemsLabel }}</span>
                        </span>
                    </label>
                    <button class="close-field-btn" title="Cerrar campo" @click="removeClinicalProblems">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="textarea-wrapper-modern">
                    <textarea
v-model="clinicalProblems" class="form-textarea-modern"
                        :placeholder="'Describe los diagnósticos presuntivos o confirmados del paciente'"
                        rows="4"></textarea>
                    <div class="textarea-footer-modern">
                        <div class="textarea-stats-modern">
                            <span class="stat-item-modern">
                                <i class="fas fa-font"></i>
                                {{ clinicalProblems.length }} caracteres
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Grid de Diagnósticos CIE-10 -->
        <div class="section-header-modern" style="margin-top: 1rem; border-bottom: none; padding-bottom: 0;">
            <div class="header-title-modern">
                <i
class="fas fa-diagnoses"
                    style="font-size: 1.125rem; background: none; -webkit-text-fill-color: #667eea; color: #667eea;"></i>
                <h5 style="font-size: 1rem; font-weight: 700; color: #344767; margin: 0;">Diagnósticos CIE-10</h5>
            </div>
        </div>

        <!-- Diagnósticos Activos -->
        <div v-if="activeDiagnosisFields.length > 0" class="diagnoses-grid-modern">
            <div
v-for="field in activeDiagnosisFields" :key="field.name" class="diagnosis-item-modern"
                :class="field.class">
                <div class="field-header-compact">
                    <label class="form-label-modern">
                        <i :class="field.icon"></i>
                        {{ field.label }}
                    </label>
                    <button
v-if="field.closeable" class="close-field-btn" title="Ocultar diagnóstico"
                        @click="toggleDiagnosisField(field.name, false)">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <MenuSelectedFull
:model-value="getDiagnosisValue(field.name)" :label="''" apiurl="cie10"
                    :can-edit-and-add="false" @update:model-value="setDiagnosisValue(field.name, $event)" />
            </div>
        </div>

        <!-- Diagnósticos Inactivos -->
        <div v-if="inactiveDiagnosisFields.length > 0" class="inactive-fields-section">
            <div class="inactive-fields-title">
                <i class="fas fa-plus-circle"></i>
                <span>Agregar diagnóstico</span>
            </div>
            <div class="inactive-fields-grid">
                <button
v-for="field in inactiveDiagnosisFields" :key="field.name" class="add-field-btn"
                    @click="toggleDiagnosisField(field.name, true)">
                    <i :class="field.icon"></i>
                    <span>{{ field.label }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Sección Estudios de Laboratorio -->
    <div id="section-estudios" ref="laboratorySection" class="studies-section-modern">
        <div class="section-header-modern">
            <div class="header-title-modern">
                <i class="fas fa-flask"></i>
                <h4>Estudios de Laboratorio y Gabinete</h4>
            </div>
        </div>

        <div v-if="isVisible('laboratoryStudies')">
            <div v-if="!isLaboratoryStudiesActive" class="add-fields-section">
                <button
class="add-field-btn" title="Agregar Estudios de laboratorio y gabinete"
                    @click="addLaboratoryStudies">
                    <i class="fas fa-vial"></i>
                    <span>{{ laboratoryStudiesLabel }}</span>
                </button>
            </div>

            <div v-if="isLaboratoryStudiesActive" class="form-group-modern">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-vial"></i>
                            <span>{{ laboratoryStudiesLabel }}</span>
                        </span>
                    </label>
                    <button class="close-field-btn" title="Cerrar campo" @click="removeLaboratoryStudies">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="textarea-wrapper-modern">
                    <textarea
v-model="laboratoryStudies" class="form-textarea-modern"
                        :placeholder="'Detalla estudios solicitados, resultados y su interpretación clínica'"
                        rows="4"></textarea>
                    <div class="textarea-footer-modern">
                        <div class="textarea-stats-modern">
                            <span class="stat-item-modern">
                                <i class="fas fa-font"></i>
                                {{ laboratoryStudies.length }} caracteres
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Sección Plan y Tratamiento -->
    <div id="section-plan" ref="treatmentSection" class="treatment-section-modern">
        <div class="section-header-modern">
            <div class="header-title-modern">
                <i class="fas fa-notes-medical"></i>
                <h4>Plan y Tratamiento</h4>
            </div>
        </div>

        <!-- Botones para agregar campos -->
        <div v-if="inactiveTreatmentFields.length > 0" class="add-fields-section">
            <button
v-for="field in inactiveTreatmentFields" :key="field.name" class="add-field-btn"
                :title="'Agregar ' + field.label" @click="addTreatmentField(field.name)">
                <i :class="field.icon"></i>
                <span>{{ field.label }}</span>
            </button>
        </div>

        <!-- Campos activos -->
        <div v-if="activeTreatmentFields.length > 0" class="fields-grid-compact">
            <!-- Plan -->
            <div v-if="isTreatmentFieldActive('plan')" class="field-group-compact full-width">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-tasks"></i>
                            <span>{{ planLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isTreatmentFieldCloseable('plan')" class="close-field-btn" title="Cerrar campo"
                        @click="removeTreatmentField('plan')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="textarea-wrapper-modern">
                    <textarea
v-model="planModel" class="form-textarea-modern"
                        placeholder="Describe el plan de manejo y seguimiento" rows="4"></textarea>
                    <div class="textarea-footer-modern">
                        <div class="textarea-stats-modern">
                            <span class="stat-item-modern">
                                <i class="fas fa-font"></i>
                                {{ planModel.length }} caracteres
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tratamiento -->
            <div v-if="isTreatmentFieldActive('treatment')" class="field-group-compact full-width">
                <div class="field-header">
                    <label class="form-label-modern">
                        <span class="label-content-modern">
                            <i class="fas fa-pills"></i>
                            <span>{{ treatmentLabel }}</span>
                        </span>
                    </label>
                    <button
v-if="isTreatmentFieldCloseable('treatment')" class="close-field-btn" title="Cerrar campo"
                        @click="removeTreatmentField('treatment')">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="textarea-wrapper-modern">
                    <textarea
v-model="treatmentModel" class="form-textarea-modern"
                        placeholder="Especifica el tratamiento farmacológico y no farmacológico" rows="4"></textarea>
                    <div class="textarea-footer-modern">
                        <div class="textarea-stats-modern">
                            <span class="stat-item-modern">
                                <i class="fas fa-font"></i>
                                {{ treatmentModel.length }} caracteres
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Last Updated -->
        <div class="last-updated-wrapper">
            <LastUpdated :updated-at="updated_at" />
        </div>
    </div>


</template>

<script setup>
import { ref, computed, watch } from 'vue';
import api from '@/services/api';
import MenuSelectedFull from '@/components/MenuSelectedFull.vue';
import { saveToLocalStorage } from '@/store/Expedientes/pacientes';
import debounce from 'lodash.debounce';
import LastUpdated from "@/components/LastUpdated.vue";

const props = defineProps({
    patientRecord: {
        type: Object,
        required: true
    },
    data: {
        type: Object,
        default: () => ({})
    }
});

// Refs para las subsecciones (para navegación)
const diagnosticsSection = ref(null);
const laboratorySection = ref(null);
const treatmentSection = ref(null);

// Exponer los refs para que el componente padre pueda acceder a ellos
defineExpose({
    diagnosticsSection,
    laboratorySection,
    treatmentSection
});

const apiData = {
    title: "Diagnósticos CIE-10",
    data: [
        { "name": "laboratoryStudies", "label": "Estudios de laboratorio y gabinete", isVisible: true, category: "1" },
        { "name": "clinicalProblems", "label": "Diagnósticos o problemas clínicos", isVisible: true, category: "1" },
        { "name": "plan", "label": "Plan", isVisible: true, category: "1" },
        { "name": "treatment", "label": "Tratamiento", isVisible: true, category: "1" }
    ]
};

const defaultFields = {
    laboratoryStudies: 'Describir estudios de laboratorio y gabinetee',
    clinicalProblems: 'Diagnósticos o problemas clínicos',
    plan: 'Plan',
    treatment: 'Tratamiento'
};

const getFieldLabel = (name) => {
    const field = apiData.data.find(field => field.name === name);
    return field ? field.label : defaultFields[name];
};

const isVisible = (name) => {
    const field = apiData.data.find(field => field.name === name);
    return field ? field.isVisible : true;
};

const laboratoryStudies = ref('');
const clinicalProblems = ref('');
const plan = ref('');
const treatment = ref('');

// Estados de expansión/colapso
const isDiagnosesExpanded = ref(false);

const laboratoryStudiesLabel = getFieldLabel('laboratoryStudies');
const clinicalProblemsLabel = getFieldLabel('clinicalProblems');
const planLabel = getFieldLabel('plan');
const treatmentLabel = getFieldLabel('treatment');

const mainDiagnosis = ref('');
const secondaryDiagnosis1 = ref('');
const secondaryDiagnosis2 = ref('');

// Normaliza valores entrantes (id u objeto con id/código)
const normalizeDiagnosisValue = (val) => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'object') {
        return val.id || val.key || val.code || val.codigo || val.clave || '';
    }
    return val;
};

// Convierte a payload (nulo o número/string)
const toPayloadDiagnosisValue = (val) => {
    const normalized = normalizeDiagnosisValue(val);
    if (normalized === '') return null;
    const asNumber = Number(normalized);
    return Number.isNaN(asNumber) ? normalized : asNumber;
};

const updated_at = ref('');

// Array de campos de diagnóstico con estado de activación
const diagnosisFields = ref([
    {
        name: 'mainDiagnosis',
        label: 'Diagnóstico Principal',
        icon: 'fas fa-star',
        class: 'diagnosis-principal',
        isActive: true, // Siempre visible
        closeable: false // El principal no se puede cerrar
    },
    {
        name: 'secondaryDiagnosis1',
        label: 'Diagnóstico Secundario',
        icon: 'fas fa-plus',
        class: 'diagnosis-secondary',
        isActive: false,
        closeable: true
    },
    {
        name: 'secondaryDiagnosis2',
        label: 'Diagnóstico Secundario',
        icon: 'fas fa-plus',
        class: 'diagnosis-secondary',
        isActive: false,
        closeable: true
    }
]);

// Computed para obtener el valor de cada diagnóstico
const getDiagnosisValue = (fieldName) => {
    switch (fieldName) {
        case 'mainDiagnosis': return mainDiagnosis.value;
        case 'secondaryDiagnosis1': return secondaryDiagnosis1.value;
        case 'secondaryDiagnosis2': return secondaryDiagnosis2.value;
        default: return '';
    }
};

// Función para actualizar el valor de cada diagnóstico
const setDiagnosisValue = (fieldName, value) => {
    console.log('🔄 Actualizando diagnóstico:', fieldName, 'con valor:', value);
    switch (fieldName) {
        case 'mainDiagnosis': mainDiagnosis.value = value; break;
        case 'secondaryDiagnosis1': secondaryDiagnosis1.value = value; break;
        case 'secondaryDiagnosis2': secondaryDiagnosis2.value = value; break;
    }
    console.log('✅ Valores actuales:', {
        mainDiagnosis: mainDiagnosis.value,
        secondaryDiagnosis1: secondaryDiagnosis1.value,
        secondaryDiagnosis2: secondaryDiagnosis2.value
    });
};

const activeDiagnosisFields = computed(() => diagnosisFields.value.filter(f => f.isActive));
const inactiveDiagnosisFields = computed(() => diagnosisFields.value.filter(f => !f.isActive));

const toggleDiagnosisField = (name, activate) => {
    const field = diagnosisFields.value.find(f => f.name === name);
    if (field) field.isActive = activate;
};

// Estados de activación para campos principales
const isClinicalProblemsActive = ref(false);
const isLaboratoryStudiesActive = ref(false);

const addClinicalProblems = () => {
    isClinicalProblemsActive.value = true;
};

const removeClinicalProblems = () => {
    isClinicalProblemsActive.value = false;
};

const addLaboratoryStudies = () => {
    isLaboratoryStudiesActive.value = true;
};

const removeLaboratoryStudies = () => {
    isLaboratoryStudiesActive.value = false;
};

// Campos de Plan y Tratamiento con estado de activación
const treatmentFields = ref([
    {
        name: 'plan',
        label: planLabel,
        icon: 'fas fa-tasks',
        placeholder: 'Describe el plan de manejo y seguimiento',
        model: '',
        isActive: false,
        closeable: true
    },
    {
        name: 'treatment',
        label: treatmentLabel,
        icon: 'fas fa-pills',
        placeholder: 'Especifica el tratamiento farmacológico y no farmacológico',
        model: '',
        isActive: false,
        closeable: true
    }
]);

// Computed para campos activos de tratamiento
const activeTreatmentFields = computed(() => {
    return treatmentFields.value.filter(field => field.isActive);
});

// Computed para campos inactivos de tratamiento
const inactiveTreatmentFields = computed(() => {
    return treatmentFields.value.filter(field => !field.isActive);
});

// Función para agregar campo
const addTreatmentField = (fieldName) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    if (field) {
        field.isActive = true;
    }
};

// Función para remover campo
const removeTreatmentField = (fieldName) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    if (field && field.closeable) {
        field.isActive = false;
    }
};

// Funciones auxiliares
const isTreatmentFieldActive = (fieldName) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    return field ? field.isActive : false;
};

const isTreatmentFieldCloseable = (fieldName) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    return field ? field.closeable : false;
};

const getTreatmentFieldValue = (fieldName) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    return field ? field.model : '';
};

const setTreatmentFieldValue = (fieldName, value) => {
    const field = treatmentFields.value.find(f => f.name === fieldName);
    if (field) {
        field.model = value;
        // Actualizar los refs originales
        if (fieldName === 'plan') plan.value = value;
        if (fieldName === 'treatment') treatment.value = value;
        debouncedSaveDiagnosticsData();
    }
};

// Computed properties para v-model
const planModel = computed({
    get: () => getTreatmentFieldValue('plan'),
    set: (value) => setTreatmentFieldValue('plan', value)
});

const treatmentModel = computed({
    get: () => getTreatmentFieldValue('treatment'),
    set: (value) => setTreatmentFieldValue('treatment', value)
});

const saveDiagnosticsData = async () => {
    console.log('💾 Guardando diagnósticos:', {
        main: mainDiagnosis.value,
        secondary1: secondaryDiagnosis1.value,
        secondary2: secondaryDiagnosis2.value
    });

    const diagnosticsData = {
        diagnostics: {
            main_diagnosis_cie10: toPayloadDiagnosisValue(mainDiagnosis.value),
            secondary_diagnosis_cie10_1: toPayloadDiagnosisValue(secondaryDiagnosis1.value),
            secondary_diagnosis_cie10_2: toPayloadDiagnosisValue(secondaryDiagnosis2.value),
            laboratory_studies: laboratoryStudies.value,
            clinical_problems: clinicalProblems.value,
            plan: plan.value,
            treatment: treatment.value
        }
    };

    console.log('📤 Payload a enviar:', diagnosticsData);

    try {
        const response = await api.put(`/pacientes/${props.patientRecord.id}/diagnostics`, diagnosticsData);
        const updatedAt = new Date(response.data.data.diagnostics.updated_at);
        updated_at.value = updatedAt.toString();
        saveToLocalStorage(`patient_${props.patientRecord.id}_diagnostics`, diagnosticsData.diagnostics);
    } catch (error) {
        console.error('Error al guardar los datos de diagnósticos:', error);
    }
};

// Debounce la función saveDiagnosticsData para que se ejecute solo después de que el usuario deje de escribir
const debouncedSaveDiagnosticsData = debounce(saveDiagnosticsData, 1000);

watch([
    mainDiagnosis,
    secondaryDiagnosis1,
    secondaryDiagnosis2,
    laboratoryStudies,
    clinicalProblems,
    plan,
    treatment
], debouncedSaveDiagnosticsData, { deep: true });

watch(() => props.data, (newData) => {
    if (newData) {
        console.log('📥 Cargando datos:', {
            main_diagnosis_cie10: newData.main_diagnosis_cie10,
            secondary_diagnosis_cie10_1: newData.secondary_diagnosis_cie10_1,
            secondary_diagnosis_cie10_2: newData.secondary_diagnosis_cie10_2
        });

        mainDiagnosis.value = normalizeDiagnosisValue(newData.main_diagnosis_cie10);
        secondaryDiagnosis1.value = normalizeDiagnosisValue(newData.secondary_diagnosis_cie10_1);
        secondaryDiagnosis2.value = normalizeDiagnosisValue(newData.secondary_diagnosis_cie10_2);

        console.log('✅ Valores asignados:', {
            mainDiagnosis: mainDiagnosis.value,
            secondaryDiagnosis1: secondaryDiagnosis1.value,
            secondaryDiagnosis2: secondaryDiagnosis2.value
        });
        laboratoryStudies.value = newData.laboratory_studies || '';
        clinicalProblems.value = newData.clinical_problems || '';

        // Activar campos si tienen contenido
        isLaboratoryStudiesActive.value = laboratoryStudies.value !== '' && laboratoryStudies.value !== null;
        isClinicalProblemsActive.value = clinicalProblems.value !== '' && clinicalProblems.value !== null;

        // Auto-activar campos de diagnóstico con datos
        diagnosisFields.value.forEach(field => {
            const value = getDiagnosisValue(field.name);
            if (value && value !== '' && value !== 0) {
                field.isActive = true;
            }
        });

        // Asegurar que el diagnóstico principal siempre esté visible
        const mainField = diagnosisFields.value.find(f => f.name === 'mainDiagnosis');
        if (mainField && !mainField.isActive) mainField.isActive = true;

        // Auto-expandir sección de Diagnósticos si hay CIE-10 asignado
        if (newData.main_diagnosis_cie10 || newData.secondary_diagnosis_cie10_1 || newData.secondary_diagnosis_cie10_2) {
            isDiagnosesExpanded.value = true;
        }

        plan.value = newData.plan || '';
        treatment.value = newData.treatment || '';

        // Sincronizar campos de tratamiento - solo activar si tienen datos
        treatmentFields.value.forEach(field => {
            if (field.name === 'plan') {
                field.model = plan.value;
                field.isActive = plan.value !== '' && plan.value !== null;
            }
            if (field.name === 'treatment') {
                field.model = treatment.value;
                field.isActive = treatment.value !== '' && treatment.value !== null;
            }
        });

        if (newData.updated_at) {
            updated_at.value = new Date(newData.updated_at).toString();
        }
    }
}, { immediate: true });
</script>

<style scoped>
/* Secciones Modernas */
.diagnosis-section-modern,
.studies-section-modern,
.treatment-section-modern {
    background: transparent;
    border-radius: 0;
    padding: 0 1.5rem;
    margin-bottom: 1.5rem;
}

/* Section Header */
.section-header-modern {
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f2f5;
}

.header-title-modern {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.header-title-modern i {
    font-size: 1.5rem;
    background: linear-gradient(310deg, #5e72e4, #825ee4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.header-title-modern h4 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #344767;
}

/* Form Groups */
.form-group-modern {
    margin-bottom: 1rem;
}

.form-label-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9375rem;
    font-weight: 600;
    color: #344767;
    margin-bottom: 0.75rem;
}

.label-content-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.label-content-modern i {
    font-size: 0.9375rem;
    color: #667eea;
}

/* Textarea Wrapper */
.textarea-wrapper-modern {
    position: relative;
    background: white;
    border: 2px solid #e9ecef;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.textarea-wrapper-modern:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea-modern {
    width: 100%;
    padding: 0.875rem 1rem;
    border: none;
    border-radius: 12px;
    font-size: 0.9375rem;
    font-weight: 400;
    color: #344767;
    line-height: 1.6;
    resize: vertical;
    min-height: 100px;
}

.form-textarea-modern:focus {
    outline: none;
}

.form-textarea-modern::placeholder {
    color: #adb5bd;
}

/* Textarea Footer */
.textarea-footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border-top: 1px solid #e9ecef;
    border-radius: 0 0 12px 12px;
}

.textarea-stats-modern {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.stat-item-modern {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #8392ab;
    font-weight: 500;
}

.stat-item-modern i {
    font-size: 0.75rem;
}

/* Help Text */
.help-text-modern {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    padding: 0.625rem 1rem;
    background: linear-gradient(135deg, #e7f3ff 0%, #f0f7ff 100%);
    border-left: 3px solid #5a9fd4;
    border-radius: 6px;
    font-size: 0.8125rem;
    color: #4a5568;
}

.help-text-modern i {
    font-size: 0.875rem;
    color: #5a9fd4;
}

/* Diagnoses Grid - Una sola columna para ver texto completo */
.diagnoses-grid-modern {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
    margin-top: 1.5rem;
}

/* En pantallas muy grandes - mantener una columna pero con más padding */
@media (min-width: 1200px) {
    .diagnoses-grid-modern {
        grid-template-columns: 1fr;
        gap: 1.5rem;
        max-width: 100%;
    }
}

.diagnosis-item-modern {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
    min-width: 0;
    /* Permite que el texto se trunque correctamente */
}

.diagnosis-item-modern .form-label-modern i {
    color: #ffc107;
    flex-shrink: 0;
}

.diagnosis-item-modern.diagnosis-principal .form-label-modern i {
    color: #667eea;
}

/* Treatment Grid */
.treatment-grid-modern {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 1.5rem;
}

/* Last Updated */
.last-updated-wrapper {
    margin-top: 0.5rem;
}

/* Campo Header Compact */
.field-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
}

.close-field-btn {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #6b7280;
}

.close-field-btn:hover {
    background: #ff6b6b;
    border-color: #ff6b6b;
    color: white;
    transform: scale(1.05);
}

.toggle-expand-btn,
.add-content-btn {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #6b7280;
    flex-shrink: 0;
}

.toggle-expand-btn:hover {
    background: #667eea;
    border-color: #667eea;
    color: white;
    transform: scale(1.05);
}

.add-content-btn {
    background: white;
    border: 2px dashed #d1d5db;
}

.add-content-btn:hover {
    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
    border-color: #667eea;
    color: #667eea;
    transform: scale(1.05);
}

/* Sección de campos inactivos */
.inactive-fields-section {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 2px dashed #e9ecef;
}

.inactive-fields-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    color: #6b7280;
    margin-bottom: 1rem;
}

.inactive-fields-title i {
    color: #667eea;
}

.inactive-fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 0.75rem;
}

.add-field-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: white;
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    transition: all 0.2s ease;
}

.add-field-btn:hover {
    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
    border-color: #667eea;
    color: #667eea;
    transform: translateY(-2px);
}

.add-field-btn i {
    font-size: 0.875rem;
}

/* Headers Colapsables */
.collapsible-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 1rem 1.25rem;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 1px solid #e9ecef;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.collapsible-header:hover {
    background: linear-gradient(135deg, #667eea10 0%, #764ba210 100%);
    border-color: #667eea;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.collapsible-header .header-title-modern {
    margin: 0;
}

.collapsible-header h5 {
    font-size: 1rem;
    font-weight: 600;
    color: #344767;
    margin: 0;
}

.toggle-section-btn {
    background: transparent;
    border: none;
    color: #6b7280;
    font-size: 1.125rem;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toggle-section-btn:hover {
    color: #667eea;
    transform: scale(1.1);
}

/* Estilos para campos individuales agregables/removibles */
.field-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.field-header-compact .form-label-modern {
    margin: 0;
    flex: 1;
}

.close-field-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 8px;
    background: #f8f9fa;
    color: #8392ab;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 1rem;
    flex-shrink: 0;
}

.close-field-btn:hover {
    background: #fee;
    color: #ef4444;
    transform: scale(1.05);
}

.close-field-btn:active {
    transform: scale(0.95);
}

/* Sección de campos inactivos */
.inactive-fields-section {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 2px dashed #e9ecef;
}

.inactive-fields-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #8392ab;
    margin-bottom: 1rem;
}

.inactive-fields-title i {
    color: #667eea;
}

.inactive-fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 0.75rem;
}

.add-field-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    border: 2px dashed #dee2e6;
    border-radius: 10px;
    background: #f8f9fa;
    color: #8392ab;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.add-field-btn:hover {
    border-color: #667eea;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
    color: #667eea;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.add-field-btn:active {
    transform: translateY(0);
}

.add-field-btn i {
    font-size: 1rem;
}

/* Responsive */
@media (max-width: 768px) {

    .diagnosis-section-modern,
    .studies-section-modern,
    .treatment-section-modern {
        padding: 1rem;
    }

    .diagnoses-grid-modern {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .treatment-grid-modern {
        grid-template-columns: 1fr;
    }

    .form-label-modern {
        font-size: 0.875rem;
    }

    .fields-grid-compact {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {

    .diagnosis-section-modern,
    .studies-section-modern,
    .treatment-section-modern {
        padding: 0.75rem;
    }

    .header-title-modern h4 {
        font-size: 1.125rem;
    }

    .form-label-modern {
        font-size: 0.8125rem;
    }
}

/* Estilos para campos agregables/removibles (nuevo diseño) */
.add-fields-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 1rem;
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 8px;
}

.add-field-btn {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.375rem 0.75rem;
    background: white;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    color: #667eea;
    font-size: 0.813rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.add-field-btn i {
    font-size: 0.75rem;
}

.add-field-btn:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-color: #667eea;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

/* Grid compacto para campos */
.fields-grid-compact {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
}

.field-group-compact {
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
}

.field-group-compact.full-width {
    grid-column: 1 / -1;
}

/* Encabezado de campo con botón de cerrar */
.field-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
}

.close-field-btn {
    padding: 0.25rem 0.5rem;
    background: transparent;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    color: #6b7280;
    font-size: 0.75rem;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.close-field-btn:hover {
    background: #fee;
    border-color: #f87171;
    color: #dc2626;
}
</style>
